/**
 * Товар считается проблемным, если не заполнено хотя бы одно из полей:
 * ИКПУ (icps) или код упаковки (packageCode).
 */
export function isProblematicRow(row) {
  const hasIkpu = String(row.icps ?? "").trim() !== "";
  const hasPackage = String(row.packageCode ?? "").trim() !== "";
  return !hasIkpu || !hasPackage;
}

/** Стабильный id для `<tr>` на странице каталога (прокрутка из JS). */
export function catalogRowDomId(rowId) {
  return `catalog-row-${String(rowId).replace(/[^a-zA-Z0-9_-]/g, "_")}`;
}
